import $ from 'jquery';

export const init = () => {
	$('input.inp__file').change(function () {
		const $this = $(this);
		if (!$this.val()) return;
		const filename = $this.val().split('\\').pop();
		$(this).attr('hidden', 'hidden');
		$(this).attr('aria-invalid', 'false');
		$this.parent().find('.inp__label-text').text(filename);
	});
};
